import { render, staticRenderFns } from "./cardMoney.vue?vue&type=template&id=5d33f071&"
import script from "./cardMoney.vue?vue&type=script&lang=js&"
export * from "./cardMoney.vue?vue&type=script&lang=js&"
import style0 from "./cardMoney.vue?vue&type=style&index=0&id=5d33f071&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports